import { Heading, Box, Flex } from '@vibe/core';

interface ErrorScreenProps {
  message: string;
}

export function ErrorScreen({ message }: ErrorScreenProps) {
  return (
    <Box>
      <div
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: 'calc(100vh - 40px)',
        }}
      >
        <Flex align="center" justify="center" direction="row">
          <div
            style={{
              marginTop: '64px',
              marginBottom: '64px',
              textAlign: 'center',
            }}
          >
            <img
              src="/emptystate.svg"
              alt=""
              style={{
                marginBottom: '20px',
                width: '400px',
              }}
            />
            <Heading type="h2">{message}</Heading>
          </div>
        </Flex>
      </div>
    </Box>
  );
}
